module.exports = __webpack_public_path__ + "images/category_lp/camera/new/assessment_achievements/3_fb1ec68d53a979ce5da07c74b4122a07.png";